import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { styled } from '../../themeCustomink';
var DogEarStyles = styled('div', {
    name: 'pigment-colorswatch-dogear',
})({
    position: 'absolute',
    width: '9px',
    height: '9px',
    left: '0',
    top: '0',
    mixBlendMode: 'normal',
    borderRadius: '4px 0px 2px',
    '.pigment-colorswatch-large &': {
        width: '12px',
        height: '12px',
    },
    '.pigment-colorswatch-blankspace': {
        width: '8px',
        height: '8px',
        left: '-0.2px',
        top: '-0.2px',
        zIndex: '10',
        position: 'absolute',
        clipPath: 'polygon(1px 1px, 0 3px, 0px 8px, 8px 0px, 3px 0)',
        background: designTokens.color.shade.white.value,
        '.pigment-colorswatch-large &': {
            width: '11px',
            height: '11px',
            clipPath: 'polygon(1px 1px, 0 3px, 0px 10.7px, 10.7px 0px, 3px 0)',
        },
    },
    '.pigment-colorswatch-fold': {
        position: 'absolute',
        left: '0%',
        right: '0%',
        top: '0%',
        bottom: '0%',
        borderBottomRightRadius: '2px',
        borderTopLeftRadius: '4px',
    },
    '.pigment-colorswatch-fold-light': {
        background: 'rgba(255, 255, 255, 0.7)',
    },
    '.pigment-colorswatch-fold-dark': {
        background: 'rgba(0, 0, 0, 0.4)',
    },
});
export var DogEarSwatch = function (_a) {
    var contrast = _a.contrast;
    var className = "pigment-colorswatch-fold pigment-colorswatch-fold-".concat(contrast === '#000' ? 'dark' : 'light');
    return (React.createElement(DogEarStyles, null,
        React.createElement("div", { className: "pigment-colorswatch-blankspace" }),
        React.createElement("div", { className: className })));
};
//# sourceMappingURL=DogEarSwatch.js.map